export const useResolvePath = () => {
    const resolvePath = (path: string | [], obj: Record<string, unknown>, separator = '.') => {
        const properties: string[] = Array.isArray(path) ? path : path.split(separator);
        return properties.reduce((prev, curr) => prev && prev[curr], obj);
    };
    return { resolvePath };
};

export default useResolvePath;
